import { useFullscreen } from 'hooks/useFullscreen';

/**
 * Global fullscreen provider that initializes the fullscreen state management.
 * This component should be placed high in the component tree to ensure
 * fullscreen state is always synced with Redux.
 */
export default function FullscreenProvider() {
  // This hook sets up global fullscreen event listeners and syncs state
  useFullscreen();

  // This component renders nothing but sets up the global fullscreen management
  return null;
}
